import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

import FilterServer from './component/service/FilterServer';
import DocServer from './component/service/DocServer';
import * as types from 'reducer/actionTypes';

class SettingService extends React.Component {
	
	componentWillMount() {
		this.props.fetchSettingDataInfo(this.props.settingKey.filterServerBrokerURI.value)
		this.props.fetchSettingDataInfo(this.props.settingKey.docServerURI.value)
		this.props.fetchSettingDataInfo(this.props.settingKey.docServerActionListenerURI.value)
	}

	onSaveFilterServerBroker = (isSingle, value) => {
		this.props.fetchSettingDataUpdate(isSingle, value, {type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST, key: this.props.settingKey.filterServerBrokerURI.value})
	}

	onSaveDocServer = (isSingle, value) => {
		this.props.fetchSettingDataUpdate(isSingle, value, {type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST, key: this.props.settingKey.docServerURI.value})
	}

	onSaveDocServerAction = (isSingle, value) => {
		this.props.fetchSettingDataUpdate(isSingle, value, {type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST, key: this.props.settingKey.docServerActionListenerURI.value})
	}
	
	render() {
		const {t} = this.props;
		return (
			<div>
				{this.props.isNullCheck(this.props.settingData.filterServerBrokerURI) ? null : 
					<FilterServer
						t = {this.props.t}
						apps={this.props.apps}
						settingKey = {this.props.settingKey.filterServerBrokerURI}
						settingData={this.props.settingData.filterServerBrokerURI}
						alertMessage={this.props.alertMessage}
						onSave={this.onSaveFilterServerBroker}
					/>
				}
				{this.props.isNullCheck(this.props.settingData.docServerURI) ? null : 
					<DocServer
						t = {this.props.t}
						apps={this.props.apps.filter((app) => app.value !== 'CELL')}
						settingKey = {this.props.settingKey.docServerURI}
						settingData={this.props.settingData.docServerURI}
						alertMessage={this.props.alertMessage}
						onSave={this.onSaveDocServer}
					/>
				}
				{this.props.isNullCheck(this.props.settingData.docServerActionListenerURI) ? null : 
					<DocServer
						t = {this.props.t}
						apps={this.props.apps.filter((app) => app.value !== 'CELL')}
						settingKey = {this.props.settingKey.docServerActionListenerURI}
						settingData={this.props.settingData.docServerActionListenerURI}
						alertMessage={this.props.alertMessage}
						onSave={this.onSaveDocServerAction}
					/>
				}
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {
		apps: reducers.setting.apps,
		settingKey: reducers.setting.settingKey,
		settingData: reducers.setting.settingData,
		apiCalling: reducers.apiCalling.apiCalling
	}
}

// 컴포넌트의 함수형 props를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		fetchSettingDataInfo: (key) => {dispatch({type: types.FETCH_GET_SETTING_DATA_INFO_REQUEST, key: key})},
		fetchSettingDataUpdate: (isSingle, value, reloadAction) => {dispatch({type: types.FETCH_SET_SETTING_DATA_UPDATE_REQUEST, isSingle: isSingle, value: value, reload: reloadAction})},	
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SettingService))